export default "__VITE_ASSET__q6tfGKm3Qmt5DJmATeHQdA__ 480w, __VITE_ASSET__LphhLScmzwPqWwTyAbd7ig__ 768w, __VITE_ASSET__tgFyw$X211zXSctfMU9_LA__ 1200w";